import { getOrderFulfillmentCTA } from "./shared";
export var Reimbursement = function Reimbursement(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return reimbursementOfShippingCostBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return reimbursementOfShippingCostBuilder(strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getOrderFulfillmentC;
        return (_getOrderFulfillmentC = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC === void 0 ? void 0 : _getOrderFulfillmentC.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getOrderFulfillmentC2, _getOrderFulfillmentC3;
        return (_getOrderFulfillmentC2 = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC2 === void 0 ? void 0 : (_getOrderFulfillmentC3 = _getOrderFulfillmentC2.getLink) === null || _getOrderFulfillmentC3 === void 0 ? void 0 : _getOrderFulfillmentC3.call(_getOrderFulfillmentC2);
      }
    }
  };
};
var reimbursementOfShippingCostBuilder = function reimbursementOfShippingCostBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "n8BFCi",
        defaultMessage: [{
          "type": 0,
          "value": "Reembolso dos custos de envio ao enviar por conta própria"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "Rfyot8",
        defaultMessage: [{
          "type": 0,
          "value": "A opção Enviar por conta própria permite-lhe usar a sua própria transportadora para enviar encomendas. O custo de envio será reembolsado pela Faire, até um determinado montante, quando o pagamento das respetivas encomendas for recebido. Pode adicionar ou atualizar o custo de envio e o número de seguimento no \"Passo 4. Informações de envio\" da página de processamento de encomenda assim que estiver disponível."
        }]
      })];
    }
  };
};